import React from 'react';
import Text from './styles';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';

interface TextDefaultProps {
  color?: string;
  fontSize?: number;
  textAlign?: 'auto' | 'left' | 'right' | 'center' | 'justify';
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
  marginTop?: number;
  text?: string;
  fontFamily?: string;
  textDecoration?: string;
  onPress?: () => void;
  style?: any;
  numberOfLines?: number;
}

function TextDefault(props: TextDefaultProps) {
  const {
    color,
    fontSize,
    textAlign,
    marginBottom,
    marginLeft,
    marginRight,
    marginTop,
    text,
    fontFamily,
    textDecoration,
    onPress,
    style,
    numberOfLines,
  } = props;

  const appTheme = useSelector((state: RootState) => state.config.appTheme);

  const styleFormat = style
    ? {...style, includeFontPadding: false}
    : {includeFontPadding: false};

  return (
    <Text
      color={color}
      fontSize={fontSize}
      textAlign={textAlign}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginTop={marginTop}
      fontFamily={fontFamily}
      textDecoration={textDecoration}
      style={styleFormat}
      appTheme={appTheme}
      adjustsFontSizeToFit={!!numberOfLines}
      numberOfLines={numberOfLines}
      onPress={onPress}>
      {text}
    </Text>
  );
}

export default TextDefault;
